
import {Component, Vue} from 'vue-property-decorator';
import {login} from "../api/user";
import {store} from "../Store";

@Component
export default class Login extends Vue {

    username = '';
    password = '';


    submit() {
        login(this.username, this.password).then((result) => {
            if (result) {
                this.$router.push({path: '/'})
            } else {
                store.addError('Wrong credentials', 'login')
            }

        }).catch((reason) => {
            alert(reason)
        });
    }

}
